import { User } from '../../app/shared/user.model';
import { Authentication } from '../../app/authentication/authentication';

export class UserHandling {
    private currentUser: User = null;
    private userRole: string;

    private isPackagingAdmin: boolean = false;
    private isPackagingEngineer: boolean = false;
    private isTestPackager: boolean = false;
    private isPartSupplierUser: boolean = false;
    private isPurchaser: boolean = false;
    private isDeveloper: boolean = false;
    private isScaniaUser: boolean = false;
    private isApprover: boolean = false;
    private isGlobalUser: boolean = false;
    private isPackaginDepartment: boolean = false;
    private isSupplierProposals: boolean = false;

    constructor() {
        let userData = localStorage.getItem("userData");
        this.currentUser = new User().deserialize(userData);
        this.userRole = this.currentUser.Roles.length > 0 ? this.currentUser.Roles[0] : "";
        this.isApprover = this.currentUser.IsApprover;

        this.isDeveloper = this.userRole == "DEVELOPER";
        this.isPackagingAdmin = this.userRole == "PACKAGING_ADMINISTRATOR";
        this.isPackagingEngineer = this.userRole == "PACKAGING_ENGINEER";
        this.isTestPackager = this.userRole == "TEST_PACKER";
        this.isPartSupplierUser = this.userRole == "PART_SUPPLIER_USER";
        this.isPurchaser = this.userRole == "PURCHASER";
        this.isScaniaUser = this.userRole == "SCANIA_USER";
        this.isPackaginDepartment = this.userRole == "PACKAGING_DEPARTMENT";
        this.isSupplierProposals = this.userRole == "SUPPLIER_PROPOSALS";
    }

    get IsSupplierProposals(): boolean {
        return this.isSupplierProposals;
    }

    get IsPackaginDepartment(): boolean {
        return this.isPackaginDepartment;
    }

    get IsPackagingAdmin(): boolean {
        return this.isPackagingAdmin;
    }

    get IsPackagingEngineer(): boolean {
        return this.isPackagingEngineer;
    }

    get IsTestPackager(): boolean {
        return this.isTestPackager;
    }

    get IsPartSupplierUser(): boolean {
        return this.isPartSupplierUser;
    }

    get IsPurchaser(): boolean {
        return this.isPurchaser;
    }

    get IsDeveloper(): boolean {
        return this.isDeveloper;
    }

    get IsScaniaUser(): boolean {
        return this.isScaniaUser;
    }

    get IsScaniaApprover(): boolean {
        return this.isApprover;
    }

    get UserName(): string {
        return this.currentUser.UserName;
    }

    get Department(): string {
        return this.currentUser.Department;
    }

    get Email(): string {
        return this.currentUser.Email;
    }

    get UserId(): string {
        return this.currentUser.UserId;
    }

    get InstructionType(): number {
        return this.currentUser.InstructionType;
    }

    get SupplierNumber(): string {
        if (!this.IsPartSupplierUser)
            return "0";
        else
            return (this.currentUser.SupplierNumber == null || this.currentUser.SupplierNumber === "")
                ? "0"
                : this.currentUser.SupplierNumber;
    }


    get ExtendedSupplierNumber(): string {
        if (!this.IsPartSupplierUser)
            return null;
        else
            return (this.currentUser.ExtendedSupplierNumber == null || this.currentUser.ExtendedSupplierNumber === "")
                ? null
                : this.currentUser.ExtendedSupplierNumber;
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/shared/user-handling.ts